import { Controller } from '@hotwired/stimulus'
import { DotLottie } from '@lottiefiles/dotlottie-web'

// Connects to data-controller="animation"
export default class extends Controller {
  static values = {
    source: String
  }

  connect () {
    this.#createCanvas()
  }

  disconnect () {
    this.lottie.destroy()
    this.canvas.remove()

    this.lottie = null
    this.canvas = null
  }

  #createCanvas () {
    this.canvas = document.createElement('canvas')
    this.canvas.classList.add('w-full', 'h-full')
    this.canvas.style.aspectRatio = '1/1'
    this.element.appendChild(this.canvas)

    this.lottie = new DotLottie({
      autoplay: true,
      loop: true,
      canvas: this.canvas,
      src: this.sourceValue
    })
  }
}
